import {
  CheckoutLineOrderField,
  ContractCheckoutsSortField,
  ContractsSortField,
  CustomerCartsSortField,
  OrderLinesSortField,
  ScgpCustomerProductOrderField,
  ScgProductOrderField
} from "@saleor/graphql";
import { createGetSortQueryVariables } from "@saleor/utils/sort";

import {
  CartDetailCustomerSortField,
  CartDetailSortField,
  ContracDetailSortField,
  ContractListUrlSortField,
  OrderDetailSortField
} from "../urls";

export function getSortQueryField(
  sort: ContractListUrlSortField
): ContractsSortField {
  switch (sort) {
    case ContractListUrlSortField.contractNo:
      return ContractsSortField.CONTRACT_NO;
    default:
      return undefined;
  }
}

export const getSortQueryVariables = createGetSortQueryVariables(
  getSortQueryField
);

export function getSortQueryContractDetailField(
  sort: ContracDetailSortField
): ScgProductOrderField {
  switch (sort) {
    case ContracDetailSortField.remain:
      return ScgProductOrderField.REMAINING_QUANTITY;
    case ContracDetailSortField.total:
      return ScgProductOrderField.TOTAL_QUANTITY;
    case ContracDetailSortField.price:
      return ScgProductOrderField.PRICE_PER_UNIT;
    default:
      return undefined;
  }
}

export const getSortQueryContractCustomerDetailVariables = createGetSortQueryVariables(
  getSortQueryContractCustomerDetailField
);

export function getSortQueryContractCustomerDetailField(
  sort: ContracDetailSortField
): ScgpCustomerProductOrderField {
  switch (sort) {
    case ContracDetailSortField.remain:
      return ScgpCustomerProductOrderField.REMAIN;
    case ContracDetailSortField.total:
      return ScgpCustomerProductOrderField.TOTAL;
    case ContracDetailSortField.price:
      return ScgpCustomerProductOrderField.PRICE;
    default:
      return undefined;
  }
}

export const getSortQueryContractDetailVariables = createGetSortQueryVariables(
  getSortQueryContractDetailField
);

export function getSortCartDetailQueryField(
  sort: CartDetailSortField
): ContractCheckoutsSortField {
  switch (sort) {
    case CartDetailSortField.linesCount:
      return ContractCheckoutsSortField.LINES_COUNT;
    default:
      return undefined;
  }
}

export function getSortCartDetailCustomerQueryField(
  sort: CartDetailCustomerSortField
): CustomerCartsSortField {
  switch (sort) {
    case CartDetailCustomerSortField.linesCount:
      return CustomerCartsSortField.LINES_COUNT;
    default:
      return undefined;
  }
}

export const getSortCartDetailQueryVariables = createGetSortQueryVariables(
  getSortCartDetailQueryField
);

export const getSortCartCustomerDetailQueryVariables = createGetSortQueryVariables(
  getSortCartDetailCustomerQueryField
);

export function getSortQueryOrderDetailField(
  sort: OrderDetailSortField
): CheckoutLineOrderField {
  switch (sort) {
    case OrderDetailSortField.remain:
      return CheckoutLineOrderField.REMAIN;
    case OrderDetailSortField.total:
      return CheckoutLineOrderField.TOTAL;
    case OrderDetailSortField.price:
      return CheckoutLineOrderField.PRICE;
    case OrderDetailSortField.contract:
      return CheckoutLineOrderField.CONTRACT;
    default:
      return undefined;
  }
}

export const getSortQueryOrderDetailVariables = createGetSortQueryVariables(
  getSortQueryOrderDetailField
);

export function getPreviewOrderQueryField(
  sort: OrderLinesSortField
): OrderLinesSortField {
  switch (sort) {
    case OrderLinesSortField.ITEM_NO:
      return OrderLinesSortField.ITEM_NO;
    default:
      return undefined;
  }
}

export const getPreviewOrderFilterTable = createGetSortQueryVariables(
  getPreviewOrderQueryField
);
